import React, { useState } from 'react';
import './FeaturedProjects.css'; // CSS for styling the component

const FeaturedProjects = () => {
    // Defaults to the first project so the preview panel is never an empty
    // rectangle at rest; hovering simply moves it.
    const [activeIndex, setActiveIndex] = useState(0);

    const projects = [
        {
            title: 'Paris 2024 Olympics RDP',
            subtitle: 'Paris 2024 Olympics Experimental Weather Forecasts.',
            link: '/ParisOlympics',
            image: process.env.PUBLIC_URL + '/images/parisbackround.png'
        },
        {
            title: 'Experimental Hurricane Model Testbed',
            subtitle: 'Hurricane Experimental Forecasts with TACC',
            link: '/hurricane',
            image: process.env.PUBLIC_URL + '/images/Hurricane%20Model.jpg'
        },
        {
            title: 'City Digital Twins',
            subtitle: 'We have been developing AUSTwin for city of Austin, UTwin for UT Campus',
            link: '/audt',
            image: process.env.PUBLIC_URL + '/images/Digital%20Twins.jpg'
        },
        {
            title: 'UT - City CoLab',
            subtitle: 'Data to Decisions for Resilient Cities',
            link: 'https://utcitycolab.org',
            image: process.env.PUBLIC_URL + '/images/CoLab.jpg'
        }
    ];

    return (
        <section className="featured-projects">
            {/* An index rather than a card grid: the titles are the interface,
                and the imagery is a preview that answers the hover. */}
            <div className="project-index">
                <div className="project-index-rows">
                    {projects.map((project, index) => (
                        <a
                            href={project.link}
                            className={`project-row ${activeIndex === index ? 'is-active' : ''}`}
                            key={index}
                            onMouseEnter={() => setActiveIndex(index)}
                            onFocus={() => setActiveIndex(index)}
                            onMouseLeave={() => setActiveIndex(0)}
                            onBlur={() => setActiveIndex(0)}
                        >
                            <span className="project-row-body">
                                <h3 className="card-title">{project.title}</h3>
                                <p className="card-subtitle">{project.subtitle}</p>
                            </span>
                            <span className="project-row-arrow" aria-hidden="true">→</span>
                        </a>
                    ))}
                </div>

                <div className="project-index-preview" aria-hidden="true">
                    {projects.map((project, index) => (
                        <span
                            key={index}
                            className={`project-preview ${activeIndex === index ? 'is-active' : ''}`}
                            style={{ backgroundImage: `url(${project.image})` }}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturedProjects;
